var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioOn = function SvgAudioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 4.15v11.7c-2.275 0-3.966-2.977-3.966-2.977H4.15a.65.65 0 0 1-.65-.65V7.728a.65.65 0 0 1 .65-.65h1.884S7.725 4.15 10 4.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.6 7.075q.305.271.547.604c.473.647.753 1.45.753 2.32a3.92 3.92 0 0 1-1.3 2.926"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M13.327 15.585A6.5 6.5 0 0 0 16.5 10a6.5 6.5 0 0 0-3.085-5.532"
  })));
};
export default SvgAudioOn;